module.exports = __webpack_public_path__ + "img/MyChoice2201_BAA.36ea2f81.jpg";